import { defineMessage } from 'services/localization';

export const messages = {
    rename: defineMessage('rename'),
    removeRuleTitle: defineMessage('remove_this_rule_block'),
    removeRule: defineMessage('remove_rule'),
};
